export { DMS_MODULE as MODULE_STORE, MODULE_API, NAME as ND_OBJEDNAVKA } from '../constants';

export { DMS_MODULE } from '../constants';
export const NAME = 'NdObjednavkaZakazka';
export const CRUMB_LABEL_KEY = 'edtMio';
